import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "@/components/PolicyPage";

export const Route = createFileRoute("/policies/terms-of-service")({
  head: () => ({
    meta: [
      { title: "Terms of Service — Coyote Creek Hat Co." },
      { name: "description", content: "The terms and conditions that govern purchases, orders, shipping, and use of the Coyote Creek Hat Co. online store and website." },
      { property: "og:title", content: "Terms of Service — Coyote Creek Hat Co." },
      { property: "og:description", content: "The terms and conditions that govern purchases, orders, shipping, and use of the Coyote Creek Hat Co. online store and website." },
      { property: "og:url", content: "https://coyotecreekhatco.com/policies/terms-of-service" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/policies/terms-of-service" }],
  }),
  component: () => <PolicyPage policyKey="termsOfService" fallbackTitle="Terms of Service" />,
});
